module.exports = __webpack_public_path__ + "img/6.5298b8e6.jpg";